import { feathersClient } from './index';

export const Cars = feathersClient.service('cars');
export const PurchasePlan = feathersClient.service('purchase-plan');
export const Settings = feathersClient.service('settings');
export const Dealers = feathersClient.service('dealers');
export const DealerSettings = feathersClient.service('dealer-settings');